import "keen-slider/keen-slider.min.css"

import './compare.scss';

import Comparison from "./components/Comparison"
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css"

function Compare({data}) {
console.log(data.compare.comparisons)
    return (
      <div className="compare-page-wrapper text-lg text-light" id="compare">
        <div className="compare-page-content">
          <div className="compare-title">
            <h1 className="text-lg text-light main-title">
              {data.compare.title}
            </h1>
            <p>{data.compare.subTitle}</p>
          </div>
        
          <Carousel showArrows={false} >
            {data.compare.comparisons.map((result) => {
              return (
                <div className="slider-container">
                  <div className="slider-item">
                    <Comparison data={result} />
                  </div>
                </div>
              );
            })}
            
          </Carousel>
        </div>
      </div>
    );
}

export default Compare
